export const TRANSFERHISTORY_LOADING = "TRANSFERHISTORY_LOADING";
export const TRANSFERHISTORY_RESET = "TRANSFERHISTORY_RESET";
export const GET_TRANSFERHISTORY = "GET_TRANSFERHISTORY";
export const GET_TRANSFERHISTORY_SUCCESS = "GET_TRANSFERHISTORY_SUCCESS";
export const GET_TRANSFERHISTORY_FAIL = "GET_TRANSFERHISTORY_FAIL";
export const DELETE_TRANSFERHISTORY = "DELETE_TRANSFERHISTORY"
export const DELETE_TRANSFERHISTORY_SUCCESS = "DELETE_TRANSFERHISTORY_SUCCESS"
export const DELETE_TRANSFERHISTORY_FAIL = "DELETE_TRANSFERHISTORY_FAIL"
export const UPDATE_TRANSFERHISTORY = "UPDATE_TRANSFERHISTORY"
export const UPDATE_TRANSFERHISTORY_SUCCESS = "UPDATE_TRANSFERHISTORY_SUCCESS"
export const UPDATE_TRANSFERHISTORY_FAIL = "UPDATE_TRANSFERHISTORY_FAIL"
export const ADD_NEW_TRANSFERHISTORY = "ADD_NEW_TRANSFERHISTORY"
export const ADD_TRANSFERHISTORY_SUCCESS = "ADD_TRANSFERHISTORY_SUCCESS"
export const ADD_TRANSFERHISTORY_FAIL = "ADD_TRANSFERHISTORY_FAIL"